export default "__VITE_ASSET__BQubd5Bv__"